import React from "react";
import Header from "../../Sections/Header";
import Footer from "../../Sections/Footer";
import Price from "../../Sections/Price";
import NicheHero from "../../Components/NicheShared/NicheHero";
import NicheFeatures, { Feature } from "../../Components/NicheShared/NicheFeatures";
import NicheSteps from "../../Components/NicheShared/NicheSteps";
import NicheCTA from "../../Components/NicheShared/NicheCTA";
import NicheFollowUp from "../../Components/NicheShared/NicheFollowUp";
import RevealOnScroll from "../../Components/RevealOnScroll";
import { NavLink } from "../../types/nav";

const LINKS: NavLink[] = [
  { label: "Início",          to: "/pizzaria#hero" },
  { label: "Funcionalidades", to: "/pizzaria#features" },
  { label: "Como funciona",   to: "/pizzaria#steps" },
  { label: "Planos",          to: "/pizzaria#price" },
];

const FEATURES: Feature[] = [
  {
    icon: "ic:baseline-local-pizza",
    title: "Montagem de pizza no chat",
    description: "Sabores, tamanhos e bordas escolhidos direto na conversa.",
  },
  {
    icon: "mdi:map-marker-check-outline",
    title: "Delivery confirmado",
    description: "Alfred pede o endereço e confirma a entrega automaticamente.",
  },
  {
    icon: "mdi:tag-multiple-outline",
    title: "Promoções automáticas",
    description: "Quinta do 2x1? Alfred já sabe e apresenta a promoção certa.",
  },
  {
    icon: "mdi:star-outline",
    title: "Avaliação pós-entrega",
    description: "Após cada pedido, Alfred pede avaliação e fortalece sua reputação.",
  },
];

const STEPS: string[] = [
  "Cadastre sabores, tamanhos e área de entrega",
  "Cliente monta o pedido completo pelo WhatsApp",
  "Alfred confirma e aciona sua cozinha",
];

const Pizzaria: React.FC = () => (
  <>
    <Header links={LINKS} />
    <NicheHero
      id="hero"
      headline={`Peça sua pizza pelo WhatsApp. <br/> O <span style="color:#E4DA1B;">Alfred</span> recebe tudo, sem app, sem taxa.`}
      subheadline="O Alfred recebe o pedido completo — sabor, tamanho, endereço — e confirma em segundos."
    />
    <RevealOnScroll><NicheFeatures id="features" features={FEATURES} /></RevealOnScroll>
    <RevealOnScroll><NicheSteps id="steps" steps={STEPS} /></RevealOnScroll>
    <RevealOnScroll>
      <NicheFollowUp
        title="Traga de volta quem não pede faz tempo. O Alfred cuida disso."
        subtitle="Follow-ups automáticos para reativar clientes com ofertas e novidades que fazem sentido."
        items={[
          "Reative clientes com promoções da semana",
          "Avise sobre novos sabores e edições limitadas",
          "Envie lembretes de promoções recorrentes (sexta da pizza, 2x1)",
        ]}
      />
    </RevealOnScroll>
    <RevealOnScroll><NicheCTA phrase="Mais pizzas entregues, menos ligação perdida." /></RevealOnScroll>
    <div id="price">
      <Price />
    </div>
    <Footer />
  </>
);

export default Pizzaria;
